window.spiResults = [];

/**
 * 回答データ収集
 */
window.collectResult = function (q, perTime, perRemain, isTimeout = false) {
  const qid = q.dataset.qid;
  const spent = perTime - perRemain;

  let userAnswer = null;

  const checks = q.querySelectorAll('.js-answer');
  if (checks.length) {
    userAnswer = [...checks].filter(x => x.checked).map(x => x.value);
  }

  const input = q.querySelector('.js-answer-text');
  if (input) userAnswer = input.value;

  window.spiResults.push({
    qid: qid,
    userAnswer: userAnswer,
    time_spent: spent,
    is_timeout: isTimeout
  });
};

/**
 * 結果送信
 */
window.submitResults = function () {

  // ajaxurl
  const ajaxUrl =
    (window.SPI_QUIZ && SPI_QUIZ.ajaxurl)
      ? SPI_QUIZ.ajaxurl
      : null;

  if (!ajaxUrl) {
    alert('ajaxurl が取得できません');
    return;
  }

  // ★★★ ここが分岐の核心 ★★★
  const examModeInput = document.getElementById('exam_mode');
  const isMock = examModeInput && examModeInput.value === 'mock';

  const resultUrl = isMock
    ? (SPI_QUIZ.mock_result_url || '/mock-result/')
    : (SPI_QUIZ.result_url || '/quiz-result/');

  fetch(ajaxUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
    body:
      'action=spi_submit_results&results=' +
      encodeURIComponent(JSON.stringify(window.spiResults))
  })
    .then(r => r.text())
    .then(txt => {

      let json;
      try {
        json = JSON.parse(txt);
      } catch (e) {
        console.error('JSON以外の応答:', txt);
        alert('結果送信に失敗しました');
        return;
      }

      if (!json.success) {
        console.error('success=false:', json);
        alert('結果送信に失敗しました');
        return;
      }

      // 結果ページへ POST 遷移
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = resultUrl;

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'results';
      input.value = JSON.stringify(json.data);

      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
    })
    .catch(err => {
      console.error(err);
      alert('通信エラーが発生しました');
    });
};
